import secureLocalStorage from '@/libs/secureLocalstorage'
import provider from '@/provider/provider'
import { SETTING_PROFILE } from '@/provider/url'

export default {
  namespaced: true,
  state: {
    profile: undefined,
  },
  mutations: {
    UPDATE_WAREHOUSE_PROFILE(state, val) {
      state.profile = val
    },
    RESET_WAREHOUSE_STATE(state) {
      state.profile = undefined
    },
  },
  actions: {
    async getWarehouseProfile({ commit }) {
      const userId = secureLocalStorage.get('userData')?.mitras?.user_id
      if (!userId) return Promise.reject(new Error('User ID not found'))
      return provider.list(`${SETTING_PROFILE}?user_id=${userId}`)
        .then(response => {
          const { warehouse } = response.data
          commit('UPDATE_WAREHOUSE_PROFILE', warehouse)
          return warehouse
        })
        .catch(error => Promise.reject(error))
    },
    resetWarehouseState({ commit }) {
      commit('RESET_WAREHOUSE_STATE')
    },
  },
}
